import localization from '../../../../shared/strings';
import { AGGREGATED_FIELD_STATE } from '../../../../store/products/helpers/aggregatedFieldState';
import { isAggregatedIdentityFieldEditable } from './aggregatedFieldHelpers';

const l10n = localization.PRODUCT_INFO.aggregated.tooltips;

export const resolveAggregatedFieldTooltip = ({
  field,
  layerReadOnly = false,
  layerReadOnlyTooltip = null,
  isIdentity = false,
  canSet = true,
  canClear = false,
} = {}) => {
  if (layerReadOnly) return layerReadOnlyTooltip || null;
  if (!field || field.state === AGGREGATED_FIELD_STATE.NOT_APPLICABLE) return null;

  if (isIdentity && !isAggregatedIdentityFieldEditable(field)) {
    return l10n.identityLocked;
  }

  if (field.state === AGGREGATED_FIELD_STATE.EMPTY) return l10n.empty;
  if (field.state === AGGREGATED_FIELD_STATE.COMMON) return l10n.common;

  if (field.state === AGGREGATED_FIELD_STATE.MULTIPLE) {
    if (canSet) return l10n.multipleEditable;
    if (canClear) return l10n.multipleClearOnly;
    return null;
  }

  return null;
};

export default resolveAggregatedFieldTooltip;
